import * as TerrassorConst from '../terrassor_const.js'
// Example de code specifique à nw.js -- ce code ne fonctionnera pas en mode web et provoquera une erreur.

/*
*
*/

console.log('NWfunctions loadeed')




/*
*
*/
export function NWcheck() {
	return (typeof(nw) != 'undefined')
}

/*
* distinction MAC / PC - BC 2018/02
*/
function laRacineData() {

    var racine = './data';
    var isMac = process.platform; // darwin pour mac
    if (isMac === "darwin") {
        racine = '../../../../../Resources/app.nw/data';     // pour mac dans "Contents\Resources\app.nw\data" et pas "Contents\Versions\56.0.2924.87\nwjs Helper.app\..."
    }
    return(racine);
}


/*
* Copie du fichier de données élève dans ./data/eleve_data.js
* @Todo : vérifier le contenu de ce fichier (doit commencer par <var eleve_data = {"name":"terrassor","version":1,> )
*/
export function NWcopyUserDataFile(filePath, modeExamen, chantierFile) {

	if(!NWcheck()) 
		return({'code':-1, 'msg':'Opération non autorisée dans la version en ligne.'})

	const fs = nw.require('fs')
	const path = require('path');

    // distinction MAC / PC - BC 2018/02
    var racine = laRacineData();

	var dir = NWgetUserDataFilePath()
    var fullDestPath = path.resolve(dir, racine, 'eleve_data.js')
    if (typeof(chantierFile) !== 'undefined') {
        // on utilise un élève vide
        var fullSrcPath = path.resolve(dir, racine+'/chantiers', 'eleve_data_vide.js')
        if (modeExamen) {
            fullSrcPath = path.resolve(dir, racine+'/chantiers', 'eleve_data_vide_examen.js')
        }
	   console.log('NWcopyUserDataFile A : ', fullSrcPath, fullDestPath)
        retour = NWcopyFileSync(fullSrcPath, fullDestPath, {'overwrite':true, 'preserveTimestamps':true})
        // le nouveau chantier ecrase le chantier
        fullDestPath = path.resolve(dir, racine, chantierFile)
	   console.log('NWcopyUserDataFile B : ', filePath, fullDestPath)
        retour = NWcopyFileSync(filePath, fullDestPath, {'overwrite':true, 'preserveTimestamps':true})
    }
    else {
        // l'étude remplace le fichier élève
	   console.log('NWcopyUserDataFile C : ', filePath, fullDestPath)
        var retour = NWcopyFileSync(filePath, fullDestPath, {'overwrite':true, 'preserveTimestamps':true})
	   console.log('Done NWcopyUserDataFile', filePath, fullDestPath)
    }


	return({'code':0, 'msg':''})

}


export function NWwriteFile(filePath, content) {
	if(!NWcheck()) {
    alert("(Mode NW seulement) Sauvgarde des données élève dans " + filePath)
		return({'code':-1, 'msg':'Pas de sauvegarde possible dans la version en ligne.'})
  }

	var fs = nw.require('fs')
	try {
		fs.writeFileSync(filePath, content, {'encoding':'utf8', 'mode':0O777, 'flag':'w'})
	} catch(err) {
		return({'code':1, 'msg':'Erreur lors de l\'écriture du fichier'})		
	}
	return({'code':0, 'msg':''})
	}


/* Chemin de stockage des données élève
* @Todo, cas de MacOsX, le chemin de l'exe pointe sur le binaire et non le dossier de l'application
* idée : path.join(process.cwd(), '../../..')
*/
export function NWgetUserDataFilePath() {
	const path = require('path');

	var dir = path.dirname(process.execPath)
	return dir
}

export function NWgetMacDataFilePath(leRep) {
  const path = require('path');
  var racine = laRacineData();
  var dir = NWgetUserDataFilePath();
  dir = path.resolve(dir, racine+'/'+leRep);
    return(dir);
}

export function NWgetUserTempDataFilePath() {
  const path = require('path');

    // distinction MAC / PC - BC 2018/02
  var racine = laRacineData();

  var dir = NWgetUserDataFilePath()
  dir = path.resolve(dir, racine+'/etudes')

  var filename = 'tmp_' + localeISOTimeString().replace(/:/g, '_') + '.terrassor' // pas de ':' dans les paths de fichier

  var filePath = path.resolve(dir, filename)
  return filePath
}


/*
*
*/
export function  NWcopyFileSync(srcFile, destFile, options) {

    return(NWcopyFileBC(srcFile, destFile)); // BC 2019

const BUF_LENGTH = 64 * 1024
const _buff = new Buffer(BUF_LENGTH)

const fs = nw.require('fs')


  const overwrite = options.overwrite
  const errorOnExist = options.errorOnExist
  const preserveTimestamps = options.preserveTimestamps

  if (fs.existsSync(destFile)) {
    if (overwrite) {
      fs.unlinkSync(destFile)
    } else if (errorOnExist) {
      throw new Error(`${destFile} already exists`)
    } else return
  }

  const fdr = fs.openSync(srcFile, 'r')
  const stat = fs.fstatSync(fdr)
  const fdw = fs.openSync(destFile, 'w', stat.mode)
  let bytesRead = 1
  let pos = 0

  while (bytesRead > 0) {
    bytesRead = fs.readSync(fdr, _buff, 0, BUF_LENGTH, pos)
    fs.writeSync(fdw, _buff, 0, bytesRead)
    pos += bytesRead
  }

  if (preserveTimestamps) {
    fs.futimesSync(fdw, stat.atime, stat.mtime)
  }

  fs.closeSync(fdr)
  fs.closeSync(fdw)
}

/*
*
*/
function  NWcopyFileBC(srcFile, destFile) {


	const fs = nw.require('fs')

    fs.createReadStream(srcFile).pipe(fs.createWriteStream(destFile));

/* et pour version plus récente
    // destination.txt will be created or overwritten by default.
    fs.copyFile(srcFile, destFile, (err) => {
        if (err) throw err;
        var mess = srcFile + " was copied to " + destFile;
        console.log(mess);
    });
    */
}


/*
*/
//vide la base et recharger l'application
export function NWresetTerrassor()
{
    alert('Actualisation de la base Terrassor, redémarrage...')

    console.log("NWresetTerrassor, delete DB")
    var request = window.indexedDB.deleteDatabase(TerrassorConst.DATABASE_NAME);
    request.onsuccess = function(e) {
      console.log("Base de données Terrassor supprimée, rechargement de la page",e)
      //window.location.reload(true)
      NWreloadTerrassor()
      };
    request.onerror = function(e) {
      console.log("Erreur lors de la suppression de la BD Terrassor", e)
      alert("Erreur lors de la suppression de la BD Terrassor")
    };
    request.onblocked = function(e) {
      console.log("BD Terrassor : blocked state", e)
      NWreloadTerrassor()
    };

    

}

export function NWreloadTerrassor() {
  console.log('calling window.location.reload(true)')
  setTimeout('window.location.reload(true)', 2000)
}



// WEBPACK FOOTER //
// ./src/client/nw/NWfunctions.js